import { Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {DatepickerModule} from 'ngx-bootstrap/datepicker';
import {DatepickerConfig} from 'ngx-bootstrap/datepicker';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RecoveryDataService } from 'src/app//services/recovery-data.service';
import {Subject} from 'rxjs';
import {RecoveryDataItemModel} from '../../models/recoveryDataItem.model';
import {UniqueDataItemModel} from '../../models/uniqueDataItems.model';
import {UniqueRecoverySchoolsDataService} from '../../services/unique-recovery-schools-data.service';
import {LessonDataService} from '../../services/lesson-data.service';
import {AuditLessonDataModel} from '../../models/auditLessonData.model';
import {AdjustedLessonModel} from "../../models/adjustedLesson.model";
import { Select2DataModel } from 'src/app/models/select2data.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { NgSelect2Component } from 'ng-select2';
import { UniqueSchoolModel } from 'src/app/models/uniqueSchool.model';
import { UniqueRecoveryClassroomsDataService } from 'src/app/services/unique-recovery-classrooms-data.service';
import { UniqueRecoveryStudentsDataService } from 'src/app/services/unique-recovery-students-data.service';
import { UniqueClassroomModel } from 'src/app/models/uniqueClassroom.model';
import { UniqueStudentModel } from 'src/app/models/uniqueStudent.model';
import { elementsFromPoint } from '@swimlane/ngx-datatable';
import { ReapplyAdjustmentService } from 'src/app/services/reapply-adjustment.service';
import { RevertAdjustmentService } from 'src/app/services/revert-adjustment.service';
import { RevertD2LAdjustmentService } from 'src/app/services/revert-d2l-adjustment.service';
import { NotifierService } from 'angular-notifier';
import { K5RevertMessageModel } from 'src/app/models/k5RevertMessage.model';

@Component({
  selector: 'app-recover-tool-datatable',
  templateUrl: './recover-tool-datatable.component.html',
  styleUrls: ['./recover-tool-datatable.component.scss']
})
export class RecoverToolDatatableComponent implements OnInit{
  reapplyResponse: any;
  revertResponse:  K5RevertMessageModel;
  d2lRevertResponse: any;
  private readonly notifier: NotifierService;

  constructor(private authService: AuthenticationService, private recoveryDataService: RecoveryDataService,
              private uniqueRecoverySchoolsDataService: UniqueRecoverySchoolsDataService,
              private uniqueRecoveryClassroomsDataService: UniqueRecoveryClassroomsDataService, private uniqueRecoveryStudentsDataService: UniqueRecoveryStudentsDataService,
              private lessonDataService: LessonDataService, private reapplyAdjustmentService: ReapplyAdjustmentService, private revertAdjustmentService: RevertAdjustmentService,
              private revertD2LAdjustmentService: RevertD2LAdjustmentService, notifierService: NotifierService) {
                this.notifier = notifierService;
  }

  static DATE_COLUMN = 6;
  private selectedStudentId: number = null;
  private selectedClassroomId: number = null;
  private selectedSchoolId: number = null;
  private reloadingTable: boolean;

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;
  recoveryData: RecoveryDataItemModel[];
  firstLoadedRecoveryData: RecoveryDataItemModel[];
  uniqueAuditData: RecoveryDataItemModel[];
  uniqueAuditDataComplete: RecoveryDataItemModel[];

  recoveryDataForModal: RecoveryDataItemModel;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  private minDate: Date = null;
  private maxDate: Date = null;

  displayTable: boolean;
  firstRowsLoaded: DataTables.Api;
  uniqueRecoveryData: UniqueDataItemModel;
  uniqueRecoveryDataComplete: UniqueDataItemModel;

  s2ClassroomData: Select2DataModel[];
  s2StudentData: Select2DataModel[];
  s2SchoolData: Select2DataModel[];
  s2ClassroomDataComplete: Select2DataModel[];
  s2StudentDataComplete: Select2DataModel[];
  s2SchoolDataComplete: Select2DataModel[];
  private s2filteredClassrooms: any = [];
  private s2filteredSchools: any = [];
  private s2filteredStudents: any = [];

  public lessonData: AuditLessonDataModel[];
  lessonDataLoaded: Promise<boolean>;
  adjustmentReapplied: Promise<boolean>;
  adjustmentReverted: Promise<boolean>;
  d2lAdjustmentReverted: Promise<boolean>;

  public successfulLessons: AdjustedLessonModel[];
  public failedLessons: AdjustedLessonModel[];

  private tableReload: boolean;

  public uniqueSchoolDataFromSvc: UniqueSchoolModel[];
  public uniqueClassroomDataFromSvc: UniqueClassroomModel[];
  public uniqueStudentDataFromSvc: UniqueStudentModel[];

  public updatedAuditRecord: RecoveryDataItemModel;
  public updatedRevertRecord: RecoveryDataItemModel;

  showModal = false;
  toggleModal = () => {
    this.showModal = !this.showModal;
  }
  // this collects the data that's first loaded into the data table
  setSchoolClassroomSearchDropDowns(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.firstRowsLoaded = dtInstance.rows( ).data();
    });
  }

  lessonDetailButtonClickHandler(info: any, row: any, index: any): void {
    this.showModal = false;
    this.lessonData = null;
    this.recoveryDataForModal = info;

    const successfulLessonNodes = info.lessonsAdjustedSuccessful;
    this.successfulLessons = info.lessonsAdjustedSuccessful;

    const failedLessonNodes = info.lessonsAdjustedFailed;
    this.failedLessons = info.lessonsAdjustedFailed;

    let lessonNodes = [];

    if (successfulLessonNodes) {
      successfulLessonNodes.forEach(function(lesson, index, array) {
        lessonNodes.push(lesson.lessonNodeId);
      });
    }
    if (failedLessonNodes){
      failedLessonNodes.forEach(function(lesson, index, array) {
        lessonNodes.push(lesson.lessonNodeId);
      });
    }

    this.lessonData = this.lessonDataService.getLessonData(lessonNodes);
  }

  reapplyAdjustments(info: any) {
    const time = Math.round(Date.now() / 1000);

    this.reapplyResponse = this.reapplyAdjustmentService.postAdjustmentData(info.id, info.classroomId, info.startingCompletionGoalConfig, 
      info.gracePeriodApplied, info.courseId, info.courseCode, info.originalCourseStartDate, info.studentAccountId, info.schoolId, 
      info.studentId, time);

      let auditRecord = this.recoveryData.find( ({ id }) => id === info.id );
      this.updatedAuditRecord = this.recoveryData.find( ({ id }) => id === info.id );
  }

  revertAdjustments(info: any) {
    const time = Math.round(Date.now() / 1000);
    let auditRecord = this.recoveryData.find( ({ id }) => id === info.id );
    this.updatedRevertRecord = this.recoveryData.find( ({ id }) => id === info.id );

    if (info.courseType == "K5") {
      // this.revertResponse = this.revertAdjustmentService.postRevertAdjustmentData(1044921, 75027020687, 7020687, 7502);
      this.revertResponse = this.revertAdjustmentService.postRevertAdjustmentData(info.id, info.studentAccountId, info.studentSchoolId, info.studentIdentityId);
    } else {
      let identityIds: number[] = [];
      info.lessonsAdjustedSuccessful.forEach(element => {        
        identityIds.push(element.lessonNodeId);        
      });

      this.d2lRevertResponse = this.revertD2LAdjustmentService.postRevertD2LAdjustmentData(info.id, info.studentIdentityId, info.schoolId, info.classroomId, identityIds)
    }
  }

  ngOnInit(): void {
    let recoveryData: any;

    let table: any;

    // get unique schools
    this.uniqueRecoverySchoolsDataService.uniqueDataItemsObservable.subscribe((data: UniqueSchoolModel[]) => {
      this.uniqueSchoolDataFromSvc = this.uniqueRecoverySchoolsDataService.getUniqueData();
      let s2dm: Select2DataModel[] = []; 
      s2dm = [] // clear this each time
      for (const [i, x] of this.uniqueSchoolDataFromSvc.entries() ){        
        s2dm.push({id:i,text:x.schoolName,searchId:x.schoolId});
        this.s2SchoolData = s2dm;        
      }
      this.s2SchoolDataComplete = this.s2SchoolData.map(x => Object.assign({}, x));
    })

    // get unique classrooms
    this.uniqueRecoveryClassroomsDataService.uniqueDataItemsObservable.subscribe((data: UniqueClassroomModel[]) => {
      this.uniqueClassroomDataFromSvc = this.uniqueRecoveryClassroomsDataService.getUniqueData();
      let s2dm: Select2DataModel[] = []; 
      s2dm = [] // clear this each time
      for (const [i, x] of this.uniqueClassroomDataFromSvc.entries() ){        
        s2dm.push({id:i,text:x.classroomName,searchId:x.classroomId});
        this.s2ClassroomData = s2dm;
      }
      this.s2ClassroomDataComplete = this.s2ClassroomData.map(x => Object.assign({}, x));
    })

    // get unique students
    this.uniqueRecoveryStudentsDataService.uniqueDataItemsObservable.subscribe((data: UniqueStudentModel[]) => {
      this.uniqueStudentDataFromSvc = this.uniqueRecoveryStudentsDataService.getUniqueData();
      let s2dm: Select2DataModel[] = []; 
      s2dm = [] // clear this each time
      for (const [i, x] of this.uniqueStudentDataFromSvc.entries() ){
        s2dm.push({id:i,text:x.lastName+', '+x.firstName,searchId:x.studentId});
        this.s2StudentData = s2dm;
      }
      this.s2StudentDataComplete = this.s2StudentData.map(x => Object.assign({}, x));    
    })

    this.lessonDataService.lessonDataItemsObservable.subscribe((data: AuditLessonDataModel[]) => {
      this.lessonData = data;
      this.lessonDataLoaded = Promise.resolve(true);
      this.showModal = true;

      if (this.successfulLessons) {
        this.successfulLessons.forEach((lesson, index, array) => {
          if (this.lessonData) {
            for (let x = 0; x < this.lessonData.length; x++) {
              if (this.lessonData[x].nodeId === parseInt(lesson.lessonNodeId, 0)) {
                lesson.displayName = this.lessonData[x].displayName;
              }
            }
          }
          if (lesson.displayName == null) {
            lesson.displayName = 'No Name Returned from Service';
          }
        });
      }

      if (this.failedLessons) {
        this.failedLessons.forEach((lesson, index, array) => {
          if (this.lessonData) {
            for (let x = 0; x < this.lessonData.length; x++) {
              if (this.lessonData[x].nodeId === parseInt(lesson.lessonNodeId, 0)) {
                lesson.displayName = this.lessonData[x].displayName;
              }
            }
          }
          if (lesson.displayName == null) {
            lesson.displayName = 'No Name Returned from Service';
          }
        });
      }
    });

    // reapply adjustments

    this.reapplyAdjustmentService.reapplyItemsObservable.subscribe((data: any) => {
      this.reapplyResponse = data;
      this.adjustmentReapplied = Promise.resolve(true);

      if (data.auditResponse.httpStatusResponse == 200) {
        this.notifier.notify('success', 'Re-apply Successful! Results:  ' + data.stepResults);
        this.updateStatusColumn(this.updatedAuditRecord, true);
                // update dt status column here
      } else {
        this.notifier.notify('error', data.auditResponse.httpStatusResponse + ' :: There was a problem processing audit request. ' + data.auditResponse.errors); 
      }
    });

    this.revertAdjustmentService.revertItemsObservable.subscribe((data: any) => {
      this.revertResponse = data;
      this.adjustmentReverted = Promise.resolve(true);
      
      if (data.error == null) {
        this.notifier.notify('success', 'Revert Successful! Results:  ' + JSON.stringify(data));      
        this.updateStatusColumn(this.updatedRevertRecord, false);                
      } else {
        this.notifier.notify('error', 'There was a problem processing audit request. ' + JSON.stringify(data));
      }
    });

    this.revertD2LAdjustmentService.revertItemsObservable.subscribe((data: any) => {
      this.d2lRevertResponse = data;
      this.d2lAdjustmentReverted = Promise.resolve(true);
      
      if (data.message.includes("200")) {
        this.notifier.notify('success', 'Revert Successful! Results:  ' + JSON.stringify(data));
      
        this.updateStatusColumn(this.updatedRevertRecord, false);
      } else {
        this.notifier.notify('error', 'There was a problem processing audit request. ' + JSON.stringify(data)); // add specific error message
      }
    });

    // retrieves data for our datatable
    this.recoveryDataService.recoveryDataItemsObservable.subscribe((data: RecoveryDataItemModel[]) => {
      this.recoveryData = data;
      if (!this.firstLoadedRecoveryData) {
        this.firstLoadedRecoveryData = data;
      }
      this.displayTable = true;

      if (this.datatableElement && this.reloadingTable) {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
          this.uniqueAuditData = data;
          dtInstance.clear().draw();
          dtInstance.rows.add(this.recoveryData);
          this.updateSelectBoxes();
          dtInstance.columns.adjust().draw();
        });
        this.reloadingTable = false;
      }
      this.buildDtOptions(this.recoveryData);
    });

    // this sets up our datepicker
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      const id = new Date(data[RecoverToolDatatableComponent.DATE_COLUMN]) || 0; // use data for the adjustment dates column
      return ((this.minDate === null) || (this.maxDate === null)) || (this.minDate <= id && id <= this.maxDate);
    });
  }
   buildDtOptions(data: RecoveryDataItemModel[]) {
      const that = this;
      this.dtOptions = {
       data,
       processing: true,
       paging: true,
       order: [ 0, 'asc'],
       columnDefs: [
         { width: '20px', targets: [ 0, 4 ] },
         { width: '44px', targets: [ 8, 9 ] },
         { targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], className: 'dt-center' },
         { targets: [11], orderable: false },
         { targets: 9,
            render: function (data, type, row, meta) {
              return '<button class="lessons-adjusted-button btn btn-link" style="background:none;border:none;color:blue;">' + data + '</button>';
            }
          }

       ],
       autoWidth: false,
       columns: [
        //  { 
        //    width: '30px',
        //    title: 'Selected',
        //    defaultContent: '<input type="checkbox">'
        //  },
         {
           title: 'Transaction ID',
           data: 'id'
         }, {
           title: 'Student ID',
           data: 'studentId'
         }, {
           title: 'First Name',
           data: 'firstName'
         }, {
           title: 'Last Name',
           data: 'lastName'
         }, {
           title: 'School Name',
           data: 'schoolName'
         }, {
           title: 'Classroom Name',
           data: 'classroomName'
         }, {
           title: 'Adjustment Date',
           defaultContent: '&mdash;',
           data: 'adjustmentDate'
         }, {
           title: 'Grace Period',
           data: 'gracePeriodConfig'
         }, {
           title: 'Adjustment Starting Completion Goal',
           defaultContent: '&mdash;',
           data: 'startingCompletionGoalConfig'
         }, {
           title: 'Total Lessons Adjusted',
           data: 'totalLessonsAdjusted'
         }, {
           title: 'Status',
           defaultContent: '&mdash;',
           data: 'status'
         }, {
           title: 'Actions',
           defaultContent: '<button class="btn-view btn btn-dark" type="button" style="margin:8px;">Re-Apply</button>'
                         + '<button class="btn-view-revert btn btn-dark" type="button" style="margin:8px;">Revert</button>'
         }],
       rowCallback: (row: Node, data: any[] | Object, index: number) => { // clicking on row logs row data for now
         const self = this;

         // Unbind first in order to avoid any duplicate handler
         // (see https://github.com/l-lin/angular-datatables/issues/87)
         $('td', row).unbind('click');
         $('td', row).on('click', '.lessons-adjusted-button',() => {
           self.lessonDetailButtonClickHandler(data, row, index);
         });

         //
         $('td', '.child').on('click', '.lessons-adjusted-button',() => {
          self.lessonDetailButtonClickHandler(data, row, index);
        });
         //

         $('td', row).on('click', '.btn-view',() => {
           self.reapplyAdjustments(data);
         });

         $('td', row).on('click', '.btn-view-revert',() => {
            self.revertAdjustments(data);
         });
         return row;
       },

      //  changing this since the buttons don't work when table shrinks...
       responsive: true,

       initComplete: () => {
         const self = this;
         self.setSchoolClassroomSearchDropDowns();
       }
     };
  }

  datePickerOnValueChange(value: Date[]): void {
    if (value !== null){
      this.minDate = value[0];
      this.maxDate = value[1];
    } else { // this clears the min/max dates to remove date filters when the dates are cleared
      this.minDate = null;
      this.maxDate = null;
    }
    this.filterById();
  }

  dpValueChange(value: Date[]): void {
    if (value !== null){
      const s = value[0].toISOString().substring(0, 10);
      const e = value[1].toISOString().substring(0, 10);
      this.minDate = value[0];
      this.maxDate = value[1];
      this.recoveryDataService.getRecoveryData(this.selectedStudentId, this.selectedSchoolId, this.selectedClassroomId, s, e, null);
      this.reloadingTable = true;
    } else { // this clears the min/max dates to remove date filters when the dates are cleared
      this.minDate = null;
      this.maxDate = null;
    }
  }

  reloadOriginalTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.minDate = null;
      this.maxDate = null;

      this.selectedStudentId = null;
      this.selectedClassroomId = null;
      this.selectedSchoolId = null;
      this.uniqueRecoveryData = this.uniqueRecoveryDataComplete;

      this.uniqueRecoveryData = Object.assign({}, this.uniqueRecoveryDataComplete);
      
      this.s2ClassroomData = this.s2ClassroomDataComplete;
      this.s2StudentData = this.s2StudentDataComplete;
      this.s2SchoolData = this.s2SchoolDataComplete;
      dtInstance.clear().draw();
      // @ts-ignore
      dtInstance.rows.add(this.firstRowsLoaded);
      dtInstance.columns.adjust().draw();
    });
    this.tableReload = false;
  }

  filterById(): void {
    if (this.datatableElement !== null && this.datatableElement !== undefined) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
      });
    }
  }

  logout(): void {
    this.authService.endSession();
  }

  onStudentSelected(studentId) {
    this.selectedStudentId = studentId;
    if (studentId == null) {
      this.tableReload = this.resetTableDataInsteadOfSearch();
    }

    if (this.tableReload) {
      this.reloadOriginalTable();
    } else {
    this.recoveryDataService.getRecoveryData(studentId, this.selectedSchoolId, this.selectedClassroomId,
        this.minDate !== null ? this.minDate.toISOString().substring(0, 10) : null,
        this.maxDate !== null ? this.maxDate.toISOString().substring(0, 10) : null,
        null);
    }
    
    this.reloadingTable = true;
  }

  onSchoolSelected(schoolId) {
    this.selectedSchoolId = schoolId;
    if (schoolId == null) {
      this.tableReload = this.resetTableDataInsteadOfSearch();
    }
    if(this.tableReload) {
      this.reloadOriginalTable();
    } else {
      this.recoveryDataService.getRecoveryData(this.selectedStudentId, schoolId, this.selectedClassroomId,
        this.minDate !== null ? this.minDate.toISOString().substring(0, 10) : null,
        this.maxDate !== null ? this.maxDate.toISOString().substring(0, 10) : null,
        null);
    }

    this.reloadingTable = true;

  }

  onClassroomSelected(classroomId) {
    this.selectedClassroomId = classroomId;
    if (classroomId == null){
      this.tableReload = this.resetTableDataInsteadOfSearch();
    } 
    if (this.tableReload) {
        this.reloadOriginalTable();
    } else {
        this.recoveryDataService.getRecoveryData(this.selectedStudentId, this.selectedSchoolId, classroomId,
          this.minDate !== null ? this.minDate.toISOString().substring(0, 10) : null,
          this.maxDate !== null ? this.maxDate.toISOString().substring(0, 10) : null,
          null);
    }

    this.reloadingTable = true;
  }

  private updateSelectBoxes() {
    this.s2filteredClassrooms = [];
    this.s2filteredSchools = [];
    this.s2filteredStudents = [];
    const fStudentz = new Set();
    const fSchoolz = new Set();
    const fClassroomz = new Set();

    this.uniqueAuditData.forEach(element => {
      fStudentz.add(element.studentId);
      fSchoolz.add(element.schoolId);
      fClassroomz.add(element.classroomId);
    });
    let classCounter = 0
    let schoolCounter = 0;
    let studentCounter = 0;
    fClassroomz.forEach(element => {
      this.uniqueClassroomDataFromSvc.forEach(el => {
        if(el.classroomId === element) {
          this.s2filteredClassrooms.push({id:classCounter,text:el.classroomName,searchId:el.classroomId});
          classCounter++;
        }
      })
    })
    fSchoolz.forEach(element => {
      this.uniqueSchoolDataFromSvc.forEach(el => {
        if(el.schoolId === element) {
          this.s2filteredSchools.push({id:schoolCounter,text: el.schoolName,searchId:el.schoolId});
          schoolCounter++;
        }
      })
    });
    fStudentz.forEach(element => {
      this.uniqueStudentDataFromSvc.forEach(el => {  
        if(el.studentId === element) {
          this.s2filteredStudents.push({id:studentCounter,text:el.lastName+', '+el.firstName,searchId:el.studentId});
          studentCounter++;
        }
      })
    })


    this.uniqueAuditData.forEach(element => {
      fStudentz.add(element.studentId);
      fSchoolz.add(element.schoolId);
      fClassroomz.add(element.classroomId);
    });

    if (this.selectedClassroomId == null) {
      this.s2ClassroomData = this.s2filteredClassrooms;
    }
    if (this.selectedStudentId == null) {
      this.s2StudentData = this.s2filteredStudents;
    }
    if (this.selectedSchoolId == null) {
      this.s2SchoolData = this.s2filteredSchools;
    }

  }

  resetTableDataInsteadOfSearch() : boolean { 
    if(this.selectedClassroomId || this.selectedSchoolId || this.selectedStudentId || this.minDate || this.maxDate){
      return false;
    }
    return true;
  }

  updateStatusColumn(auditRecord: RecoveryDataItemModel, reapply: boolean) {
     auditRecord.status = reapply ? 'RE-APPLIED' : 'REVERTED';
      this.reloadingTable = true;
      this.uniqueAuditData = this.recoveryData;
  
      if (this.datatableElement && this.reloadingTable) {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {        
          dtInstance.clear().draw();
          dtInstance.rows.add(this.recoveryData);
          this.updateSelectBoxes();
          dtInstance.columns.adjust().draw();
        });
        this.reloadingTable = false;
      }
      this.buildDtOptions(this.recoveryData);
    }
}
